import * as types from './types';

import { postRequest } from '../../services/requestService';
import { showErrorToast } from '../../services/notificationsService';

/**
 * Fetch assets for current buyer
 */
export const fetchAssets = () => async (dispatch) => {
  const payload = {
    isFetchingAssets: false,
    assets: [],
  };
  dispatch({
    type: types.SET_IS_FETCHING_ASSETS,
    payload: { isFetchingAssets: true },
  });

  try {
    const response = await postRequest('/buyers/assets/get-assets');
    const { assets } = response.data;
    payload.assets = assets;
  } catch (e) {
    showErrorToast(`Fetching assets failed: ${e.message}`);
  }
  dispatch({
    type: types.SET_ASSETS,
    payload,
  });
};
